import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AssignmentReminder } from './participated-assignment-card.styles';
import { Button, Tag, Tooltip } from 'antd';
import { ArrowRightOutlined, BellOutlined, CalendarOutlined } from '@ant-design/icons';
import { UnixTimestamp } from '@module/assignment';
import { participatedAssignmentTeacher, ParticipatedAssignmentProgress, ParticipatedAssignmentTiming, ParticipatedAssignmentTypeTag } from './participated-assignment-summary.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ParticipatedAssignmentReminder = function ParticipatedAssignmentReminder(props) {
  var item = props.item,
      labels = props.labels;
  var summaryProps = item ? _objectSpread(_objectSpread({}, props), {}, {
    item: item
  }) : null;
  var teacher = item ? participatedAssignmentTeacher(item, labels) : '';
  var deadline = UnixTimestamp.parseMilliseconds(item === null || item === void 0 ? void 0 : item.endTime);
  var dueSoon = deadline !== null && deadline > props.now && deadline - props.now <= 24 * 60 * 60 * 1000 && !!(item !== null && item !== void 0 && item.canOpen(props.now));
  return /*#__PURE__*/_jsxs(AssignmentReminder, {
    className: "reminder",
    "aria-label": props.title,
    "aria-busy": props.refreshing,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "reminder-heading",
      children: [/*#__PURE__*/_jsx("span", {
        className: "reminder-icon",
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx(BellOutlined, {})
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h2", {
          children: props.countLabel
        }), props.summaryLabel && /*#__PURE__*/_jsx("p", {
          className: "muted",
          children: props.summaryLabel
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "reminder-body",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "reminder-info",
        children: [item && summaryProps ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "reminder-title",
            children: [/*#__PURE__*/_jsx(ParticipatedAssignmentTypeTag, _objectSpread({}, summaryProps)), /*#__PURE__*/_jsx(Tooltip, {
              title: item.title,
              children: /*#__PURE__*/_jsx("h3", {
                children: item.title
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "metadata",
            children: [/*#__PURE__*/_jsxs("span", {
              className: "reminder-teacher",
              children: [/*#__PURE__*/_jsx(Tooltip, {
                title: teacher,
                children: /*#__PURE__*/_jsx("span", {
                  className: "assignment-teacher",
                  children: teacher
                })
              }), /*#__PURE__*/_jsxs("span", {
                className: "assignment-code",
                children: ["\xB7 #", item.idNumber]
              })]
            }), /*#__PURE__*/_jsx(ParticipatedAssignmentTiming, _objectSpread({}, summaryProps)), /*#__PURE__*/_jsx(ParticipatedAssignmentProgress, _objectSpread({}, summaryProps))]
          }), deadline !== null && /*#__PURE__*/_jsxs("div", {
            className: "reminder-deadline",
            children: [dueSoon && /*#__PURE__*/_jsx(Tag, {
              color: "gold",
              children: props.dueSoonLabel
            }), /*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), " ", labels.due, " ", props.formatTime(deadline)]
            })]
          })]
        }) : /*#__PURE__*/_jsx("p", {
          className: "no-available muted",
          children: props.unavailableLabel
        }), props.failed && /*#__PURE__*/_jsxs("div", {
          className: "reminder-error",
          role: "status",
          children: [/*#__PURE__*/_jsx("span", {
            children: props.errorLabel
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            size: "small",
            onClick: props.onRetry,
            children: props.retryLabel
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "reminder-actions",
        children: [/*#__PURE__*/_jsxs(Button, {
          type: "link",
          onClick: props.onViewAll,
          "aria-label": props.viewAll,
          children: [/*#__PURE__*/_jsx("span", {
            className: "reminder-view-full",
            children: props.viewAll
          }), /*#__PURE__*/_jsx("span", {
            className: "reminder-view-short",
            children: props.viewAllShort
          })]
        }), item && /*#__PURE__*/_jsxs(Button, {
          type: "primary",
          onClick: function onClick() {
            return props.onOpen(item);
          },
          "aria-label": "".concat(labels.viewDetails, ": ").concat(item.title),
          children: [labels.viewDetails, " ", /*#__PURE__*/_jsx(ArrowRightOutlined, {})]
        })]
      })]
    })]
  });
};